import { Coins } from 'lucide-react'
import { Instrument, VisualizationType, ChartPeriod } from './types'

export const instruments: Instrument[] = [
  { id: 'gold', name: 'Gold', icon: Coins, apiType: 'precious' },
  { id: 'silver', name: 'Silver', icon: Coins, apiType: 'precious' },
  { id: 'platinum', name: 'Platinum', icon: Coins, apiType: 'precious' },
  { id: 'palladium', name: 'Palladium', icon: Coins, apiType: 'precious' },
/*   { id: 'rhodium', name: 'Rhodium', icon: Coins, apiType: 'precious' }, */
  { id: 'oil', name: 'Oil', icon: Coins, apiType: 'oil' },
  { id: 'copper', name: 'Copper', icon: Coins, apiType: 'base' },
  { id: 'nickel', name: 'Nickel', icon: Coins, apiType: 'base' },
  { id: 'aluminum', name: 'Aluminum', icon: Coins, apiType: 'base' },
  { id: 'zinc', name: 'Zinc', icon: Coins, apiType: 'base' },
  { id: 'lead', name: 'Lead', icon: Coins, apiType: 'base' },
  /* { id: 'uranium', name: 'Uranium', icon: Coins, apiType: 'base' }, */
]

export const instrumentsBase: Instrument[] = [
  { id: 'gold', name: 'Gold', icon: Coins, apiType: 'precious' },
  { id: 'silver', name: 'Silver', icon: Coins, apiType: 'precious' },
  { id: 'platinum', name: 'Platinum', icon: Coins, apiType: 'precious' },
  { id: 'palladium', name: 'Palladium', icon: Coins, apiType: 'precious' },
/*   { id: 'rhodium', name: 'Rhodium', icon: Coins, apiType: 'precious' }, */
  { id: 'oil', name: 'Oil', icon: Coins, apiType: 'oil' },
  { id: 'copper', name: 'Copper', icon: Coins, apiType: 'base' },
  { id: 'nickel', name: 'Nickel', icon: Coins, apiType: 'base' },
  { id: 'aluminum', name: 'Aluminum', icon: Coins, apiType: 'base' },
  { id: 'zinc', name: 'Zinc', icon: Coins, apiType: 'base' },
  { id: 'lead', name: 'Lead', icon: Coins, apiType: 'base' },
  /* { id: 'uranium', name: 'Uranium', icon: Coins, apiType: 'base' }, */
  { id: 'bitcoin', name: 'Bitcoin', icon: Coins, apiType: 'cryptos' },
  { id: 'ethereum', name: 'Ethereum', icon: Coins, apiType: 'cryptos' },
  { id: 'solana', name: 'Solana', icon: Coins, apiType: 'cryptos' },
  { id: 'cardano', name: 'Cardano', icon: Coins, apiType: 'cryptos' },
  { id: 'avalanche', name: 'Avalanche', icon: Coins, apiType: 'cryptos' },
  { id: 'chainlink', name: 'Chainlink', icon: Coins, apiType: 'cryptos' },
  { id: 'tron', name: 'TRON', icon: Coins, apiType: 'cryptos' },
  { id: 'ripple', name: 'Ripple', icon: Coins, apiType: 'cryptos' },
  { id: 'binance', name: 'Binance Coin', icon: Coins, apiType: 'cryptos' },
  { id: 'sui', name: 'Sui', icon: Coins, apiType: 'cryptos' },
/*   { id: 'toncoin', name: 'Toncoin', icon: Coins, apiType: 'crypto' },
  { id: 'filecoin', name: 'Filecoin', icon: Coins, apiType: 'crypto' }, */
]; 


export const visualizationTypes: VisualizationType[] = [
  { id: 'text', name: 'Text' },
  { id: 'bubbles', name: 'Bubbles' },
  { id: 'pieCharts', name: 'Pie Chart' },
  { id: 'charts', name: 'Charts' }
]

export const chartPeriods: ChartPeriod[] = [
  { id: 'realTime', name: 'Real Time' },
  { id: '30days', name: '30 Days' },
  { id: '60days', name: '60 Days' },
  { id: '6months', name: '6 Month' },
  { id: '1year', name: '1 Year' },
  { id: '5years', name: '5 Years' },
  { id: '10years', name: '10 Years' },
]
